import type { VFC } from 'react'
import { Size } from '@opallabs/gem'
import { ThemeProvider } from '@opallabs/hooks'
import { Button, ButtonIconPosition, Icon } from '@opallabs/lapidary'
import { ViewHeader } from '@opallabs/lapidary-unstable'
import type { HeaderProps } from './types'

export const Header: VFC<HeaderProps> = ({
  isViewOnlyUser,
  onClickCreate,
  onSearch,
  theme = 'light',
}) => (
  <ViewHeader
    actionsChildren={
      <ThemeProvider theme={theme}>
        {!isViewOnlyUser && (
          <Button
            ariaLabel="Create Presentation"
            buttonText="Create Presentation"
            className="create-presentation"
            icon={
              <Icon
                ariaHidden={true}
                glyph="gem-add"
                height={Size.Icon}
                width={Size.Icon}
              />
            }
            iconPosition={ButtonIconPosition.leading}
            name="Create Presentation"
            onClick={onClickCreate}
            variant="primary"
          />
        )}
      </ThemeProvider>
    }
    onSearch={onSearch}
    searchInputWrapperId="presentations_dashboard_search-wrapper"
    theme={theme}
    title="Presentations"
  />
)
